import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

function communityBase(clientViewId, communityId) {
  return `/views/${clientViewId}/communities/${communityId}`;
}

function courseBase(clientViewId, courseId) {
  return `/views/${clientViewId}/courses/${courseId}`;
}

export function getPublishingDashboard(clientViewId) {
  return clientPortalRequest(`/views/${clientViewId}/publishing/dashboard`);
}

export function listPendingSubmissions(clientViewId, params = {}) {
  return clientPortalRequest(`/views/${clientViewId}/publishing/pending${buildClientQuery(params)}`);
}

export function getPublishingDetail(clientViewId, contentVersionId) {
  return clientPortalRequest(`/views/${clientViewId}/publishing/${contentVersionId}`);
}

export function approveSubmission(clientViewId, contentVersionId, body = {}) {
  return clientPortalRequest(`/views/${clientViewId}/publishing/${contentVersionId}/approve`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function rejectSubmission(clientViewId, contentVersionId, body) {
  return clientPortalRequest(`/views/${clientViewId}/publishing/${contentVersionId}/reject`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function publishSubmission(clientViewId, contentVersionId) {
  return clientPortalRequest(`/views/${clientViewId}/publishing/${contentVersionId}/publish`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function saveCommunityDraft(clientViewId, communityId, body) {
  return clientPortalRequest(`${communityBase(clientViewId, communityId)}/draft`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function submitCommunityForReview(clientViewId, communityId) {
  return clientPortalRequest(`${communityBase(clientViewId, communityId)}/submit-review`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function listCommunityVersions(clientViewId, communityId) {
  return clientPortalRequest(`${communityBase(clientViewId, communityId)}/versions`);
}

export function previewCommunity(clientViewId, communityId, params = {}) {
  return clientPortalRequest(
    `${communityBase(clientViewId, communityId)}/preview${buildClientQuery(params)}`
  );
}

export function saveCourseDraft(clientViewId, courseId, body) {
  return clientPortalRequest(`${courseBase(clientViewId, courseId)}/draft`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function submitCourseForReview(clientViewId, courseId) {
  return clientPortalRequest(`${courseBase(clientViewId, courseId)}/submit-review`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function listCourseVersions(clientViewId, courseId) {
  return clientPortalRequest(`${courseBase(clientViewId, courseId)}/versions`);
}

export function previewCourse(clientViewId, courseId, params = {}) {
  return clientPortalRequest(
    `${courseBase(clientViewId, courseId)}/preview${buildClientQuery(params)}`
  );
}
